import { ReactNode } from "react"
import { Link } from "react-router-dom"
import GuardianIcon from "@/components/common/GuardianIcon"
import { GuardianIconName } from "@/constants/guardianIconNames"

export function ProfileMenuLink({
  to,
  icon,
  title,
  sub,
  badge,
  onClick,
  iconNode,
}: {
  to?: string
  icon?: GuardianIconName
  title: string
  sub: string
  badge?: boolean
  onClick?: () => void
  iconNode?: ReactNode
}) {
  const className =
    "flex w-full flex-row items-center gap-3 rounded-2xl border border-violet-400/35 bg-violet-400/10 p-3.5 text-left"

  const inner = (
    <>
      {icon ? (
        <span className="relative shrink-0">
          <GuardianIcon name={icon} size={28} />
          {badge ? (
            <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 rounded-full border border-guardians-bg bg-red-500" />
          ) : null}
        </span>
      ) : iconNode ? (
        <span className="relative shrink-0">{iconNode}</span>
      ) : null}
      <span className="min-w-0 flex-1">
        <span className="block text-[15px] font-extrabold text-white">{title}</span>
        <span className="block text-xs text-white/50">{sub}</span>
      </span>
      <span className="text-lg text-white/35">›</span>
    </>
  )

  if (to) {
    return (
      <Link to={to} className={className}>
        {inner}
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {inner}
    </button>
  )
}
